/* ============================================================
   TRENDYROP — theme.js  (vanilla, no dependencies)
   Cart drawer, menu drawer, predictive search, variant picker,
   gallery, sticky ATC, quantity, device finder.
   Works with Shopify Theme Editor section lifecycle.
   ============================================================ */
(function () {
  'use strict';
  const T = window.TRENDYROP || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function money(cents) {
    const fmt = (T.moneyFormat || '${{amount}}');
    const amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  /* ---------- generic drawer open/close ---------- */
  let overlay;
  function ensureOverlay() {
    overlay = $('#DrawerOverlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'DrawerOverlay';
      overlay.className = 'drawer__overlay';
      document.body.appendChild(overlay);
      overlay.addEventListener('click', closeAllDrawers);
    }
    return overlay;
  }
  function openDrawer(sel) {
    const d = typeof sel === 'string' ? $(sel) : sel;
    if (!d) return;
    ensureOverlay().classList.add('is-open');
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const focusable = d.querySelector('button,a,input');
    if (focusable) focusable.focus();
  }
  function closeAllDrawers() {
    $$('.drawer.is-open').forEach(d => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAllDrawers(); });
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      const sel = opener.getAttribute('data-drawer-open');
      openDrawer(sel);
      if (sel === '#CartDrawer') renderCartDrawer(); /* always show the live basket */
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeAllDrawers(); }
  });

  /* ---------- cart ---------- */
  async function fetchCart() {
    const r = await fetch(T.routes.cart_url + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    return r.json();
  }
  /* server-rendered savings (sale vs RRP + bundle/automatic discounts) via the Section Rendering API */
  async function fetchSavings() {
    try {
      const r = await fetch(T.routes.cart_url + '?sections=cart-savings', { cache: 'no-store' });
      if (!r.ok) return null;
      const j = await r.json();
      const wrap = document.createElement('div');
      wrap.innerHTML = j['cart-savings'] || '';
      return wrap;
    } catch (e) { return null; }
  }
  /* every render takes a ticket, so a slower older response (e.g. the page-load refresh)
     can never overwrite a newer one (e.g. right after Add to basket) */
  let renderSeq = 0;
  async function renderCartDrawer() {
    const drawer = $('#CartDrawer');
    if (!drawer) return;
    const mySeq = ++renderSeq;
    try {
      const res = await Promise.all([fetchCart(), fetchSavings()]);
      if (mySeq !== renderSeq) return;
      const cart = res[0], savings = res[1];
      updateCartCount(cart.item_count);
      const body = $('#CartDrawerBody');
      const foot = $('#CartDrawerFoot');
      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-empty"><p>' + (T.strings.emptyCart || 'Your basket is empty.') + '</p><button class="btn btn--primary" data-drawer-close>Continue shopping</button></div>';
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;
      let was = [];
      if (savings) { try { was = JSON.parse((savings.querySelector('[data-line-was]') || {}).textContent || '[]'); } catch (e) { was = []; } }
      if (!Array.isArray(was) || was.length !== cart.items.length) was = [];
      body.innerHTML = cart.items.map((it, i) => cartLineHTML(it, i, was[i] || 0)).join('');
      renderMeter(cart.total_price);
      const sub = $('#CartDrawerSubtotal');
      if (sub) sub.textContent = money(cart.total_price);
      renderCartSavings(cart, savings);
    } catch (e) { /* noop */ }
  }
  /* "You're saving £X" box, recomputed from the live cart on every render */
  function renderCartSavings(cart, savings) {
    const box = $('#CartDrawerSavings');
    const src = savings ? savings.querySelector('[data-cart-savings]') : null;
    let html = src ? src.innerHTML : '';
    if (!src && (cart.total_discount || 0) > 0) {
      html = '<div class="csv"><div class="csv__head">🎉 You\'re saving <b>' + money(cart.total_discount) + '</b> on this order</div></div>';
    }
    if (box) { box.innerHTML = html; box.hidden = html.indexOf('class="csv"') < 0; }
    /* legacy row (older drawer markup) */
    const saveRow = $('#CartDrawerSaveRow');
    const saveEl = $('#CartDrawerSave');
    if (saveRow && saveEl) {
      const save = cart.total_discount || 0;
      if (save > 0) { saveEl.textContent = '−' + money(save); saveRow.hidden = false; }
      else { saveRow.hidden = true; }
    }
  }
  function cartLineHTML(it, i, lineWas) {
    const was = Math.max(it.original_line_price || 0, lineWas || 0);
    const saveAmt = was - it.final_line_price;
    const discs = (it.line_level_discount_allocations || []).map(a => (a.discount_application && a.discount_application.title) ? '<div class="cart-line__disc">✓ ' + a.discount_application.title + '</div>' : '').join('');
    const priceHTML = saveAmt > 0
      ? '<span class="cart-line__was">' + money(was) + '</span> ' + money(it.final_line_price) + '<div class="cart-line__save">Saved ' + money(saveAmt) + '</div>'
      : money(it.final_line_price);
    return '<div class="cart-line" data-line="' + (i + 1) + '">' +
      '<div class="cart-line__im"><img src="' + (it.image ? it.image.replace(/(\.[^.]+)$/, '_160x$1') : '') + '" alt="" width="72" height="90" loading="lazy"></div>' +
      '<div><div style="font-weight:700">' + it.product_title + '</div>' +
      '<div style="font-size:12.5px;color:var(--tr-muted)">' + (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '') + '</div>' +
      discs +
      '<div class="qty" style="margin-top:8px"><button data-qty="-" aria-label="Decrease">&minus;</button><input type="text" value="' + it.quantity + '" data-qty-input inputmode="numeric" aria-label="Quantity"><button data-qty="+" aria-label="Increase">+</button></div></div>' +
      '<div style="text-align:right"><div class="price">' + priceHTML + '</div>' +
      '<button style="font-size:12px;color:var(--tr-muted);background:none;border:0;cursor:pointer" data-remove>Remove</button></div></div>';
  }
  function renderMeter(total) {
    const meter = $('#FreeShipMeter');
    if (!meter || !T.freeShipThreshold) return;
    const remaining = Math.max(0, T.freeShipThreshold - total);
    const pct = Math.min(100, (total / T.freeShipThreshold) * 100);
    meter.querySelector('[data-meter-bar]').style.width = pct + '%';
    meter.querySelector('[data-meter-text]').innerHTML = remaining === 0
      ? "🚚 You've unlocked <b style='color:var(--tr-success)'>free UK delivery</b>!"
      : '🚚 You\'re <b>' + money(remaining) + '</b> from free UK delivery';
  }
  function updateCartCount(n) { $$('.cart-count').forEach(el => { el.textContent = n; el.hidden = n === 0; }); }

  async function addToCart(form) {
    const btn = form.querySelector('[type="submit"]');
    const original = btn ? btn.textContent : '';
    const wasDisabled = btn ? btn.disabled : false;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      const fd = new FormData(form);
      const extras = typeof form.__bundleExtras === 'function' ? form.__bundleExtras() : [];
      let r;
      if (extras.length) {
        /* bundle: main product + selected add-ons in ONE request, so the tiered automatic discount applies to all of them */
        const items = [];
        const mainId = parseInt(fd.get('id'), 10);
        if (mainId) {
          const main = { id: mainId, quantity: parseInt(fd.get('quantity'), 10) || 1 };
          const props = {};
          fd.forEach((v, k) => { const m = /^properties\[(.+)\]$/.exec(k); if (m && v !== '') props[m[1]] = v; });
          if (Object.keys(props).length) main.properties = props;
          items.push(main);
        }
        r = await fetch(T.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items.concat(extras) })
        });
      } else {
        r = await fetch(T.routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      }
      const data = await r.json();
      if (r.ok) {
        if (typeof form.__bundleReset === 'function') form.__bundleReset();
        if ($('#CartDrawer') && (window.__cartDrawerEnabled !== false)) { showUpdating(); openDrawer('#CartDrawer'); await renderCartDrawer(); }
        else window.location = T.routes.cart_url;
      } else { alert(data.description || data.message || 'Could not add to cart.'); }
    } catch (e) { window.location = T.routes.cart_url; }
    finally { if (btn) { btn.disabled = wasDisabled; btn.textContent = original; } }
  }
  /* opened straight after a successful add: never show a stale "empty" message while it refreshes */
  function showUpdating() {
    const body = $('#CartDrawerBody');
    if (body && !body.querySelector('.cart-line')) body.innerHTML = '<p style="color:var(--tr-muted)">Updating your basket…</p>';
  }
  /* small public hook so other scripts/apps can refresh or open the drawer */
  window.TrendyropCart = { refresh: renderCartDrawer, open: function () { openDrawer('#CartDrawer'); } };
  async function changeLine(line, quantity) {
    const r = await fetch(T.routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    });
    await r.json();
    await renderCartDrawer();
    if (document.body.classList.contains('template-cart')) window.location.reload();
  }

  document.addEventListener('submit', e => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (form) { e.preventDefault(); addToCart(form); }
  });
  document.addEventListener('click', e => {
    const line = e.target.closest('[data-line]');
    if (e.target.closest('[data-remove]') && line) { changeLine(+line.dataset.line, 0); return; }
    const qb = e.target.closest('[data-qty]');
    if (qb && line) {
      const input = line.querySelector('[data-qty-input]');
      let q = parseInt(input.value, 10) || 1;
      q = qb.dataset.qty === '+' ? q + 1 : Math.max(0, q - 1);
      changeLine(+line.dataset.line, q);
    }
  });

  /* ---------- variant picker (PDP) ---------- */
  function initProduct(scope) {
    const root = scope.querySelector ? scope.querySelector('[data-product-root]') : null;
    const el = (scope.matches && scope.matches('[data-product-root]')) ? scope : root;
    if (!el) return;
    initGallery(el);
    let variants;
    try { variants = JSON.parse(el.querySelector('[data-variants-json]').textContent); } catch (e) { return; }
    const form = el.querySelector('form[action*="/cart/add"]');
    const idInput = form ? form.querySelector('[name="id"]') : null;
    const priceEl = el.querySelector('[data-price]');
    const stickyPrice = el.querySelector('[data-sticky-price]');
    const stickyVariant = el.querySelector('[data-sticky-variant]');
    const atcBtn = form ? form.querySelector('[type="submit"]') : null;

    function current() {
      const chosen = $$('[data-opt]', el).filter(i => i.checked).map(i => i.value);
      return variants.find(v => v.options.every((o, idx) => o === chosen[idx]));
    }
    function update(first) {
      // update the color name label from the selected swatch
      const cn = el.querySelector('[data-color-name]');
      if (cn) { const ci = el.querySelector('.swatches input:checked'); if (ci) cn.textContent = ci.value; }
      const v = current();
      if (!v) { if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = T.strings.unavailable; } return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.compare_at_price > v.price
        ? '<span class="price__now">' + money(v.price) + '</span><span class="price__compare">' + money(v.compare_at_price) + '</span>'
        : '<span class="price__now">' + money(v.price) + '</span>';
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (stickyVariant) stickyVariant.textContent = v.title;
      if (atcBtn) { atcBtn.disabled = !v.available; atcBtn.textContent = v.available ? T.strings.addToCart : T.strings.soldOut; }
      // update selected image (scroll carousel to the variant's photo)
      if (v.featured_media && v.featured_media.id) selectMedia(el, v.featured_media.id, !first);
      // swatch/pill visual state
      $$('.swatches label, .variant-pills label', el).forEach(l => {
        const inp = l.querySelector('input'); if (inp) l.classList.toggle('is-on', inp.checked);
      });
    }
    $$('[data-opt]', el).forEach(i => i.addEventListener('change', function () { update(false); }));
    update(true);
  }
  /* product gallery: swipeable scroll-snap carousel + thumbnail nav + color sync */
  function initGallery(el) {
    const car = el.querySelector('[data-gallery-carousel]');
    if (!car || car.__init) return;
    car.__init = true;
    const count = () => car.querySelectorAll('.gslide').length;
    const activeIndex = () => Math.round(car.scrollLeft / Math.max(1, car.clientWidth));
    function setActive(i) {
      $$('[data-media-id]', el).forEach(t => t.setAttribute('aria-current', (+t.getAttribute('data-index') === i) ? 'true' : 'false'));
    }
    el.__galleryGo = function (i, smooth) {
      if (i < 0 || i >= count()) return;
      car.scrollTo({ left: i * car.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    };
    el.__galleryGoMedia = function (mediaId, smooth) {
      const i = $$('.gslide', car).findIndex(s => s.getAttribute('data-slide-id') === String(mediaId));
      if (i >= 0) el.__galleryGo(i, smooth);
    };
    let raf;
    car.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => setActive(activeIndex())); }, { passive: true });
    setActive(activeIndex());
  }
  function selectMedia(el, mediaId, smooth) {
    if (el && el.__galleryGoMedia) el.__galleryGoMedia(mediaId, smooth);
  }
  document.addEventListener('click', e => {
    const thumb = e.target.closest('[data-media-id]');
    if (thumb) { const el = thumb.closest('[data-product-root]'); if (el && el.__galleryGo) el.__galleryGo(+thumb.getAttribute('data-index')); }
  });

  /* ---------- sticky ATC visibility ---------- */
  function initSticky(scope) {
    const sticky = scope.querySelector ? scope.querySelector('.sticky-atc') : null;
    const anchor = scope.querySelector ? scope.querySelector('[data-atc-anchor]') : null;
    if (!sticky || !anchor || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => { sticky.style.transform = en.isIntersecting ? 'translateY(120%)' : 'none'; });
    }, { rootMargin: '0px 0px -80% 0px' });
    io.observe(anchor);
  }

  /* ---------- predictive search ---------- */
  function initSearch(scope) {
    const input = scope.querySelector ? scope.querySelector('[data-predictive-input]') : null;
    if (!input) return;
    const panel = input.closest('[data-search]').querySelector('.predictive');
    let timer;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { if (panel) panel.classList.remove('is-open'); return; }
      timer = setTimeout(async () => {
        try {
          const url = T.routes.predictive_search_url + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
          const r = await fetch(url);
          const text = await r.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const results = doc.querySelector('.predictive__results');
          if (panel && results) { panel.innerHTML = results.innerHTML; panel.classList.add('is-open'); }
        } catch (e) { /* noop */ }
      }, 220);
    });
    document.addEventListener('click', e => { if (panel && !e.target.closest('[data-search]')) panel.classList.remove('is-open'); });
  }

  /* ---------- device finder routing ---------- */
  function initFinder(scope) {
    const finder = scope.querySelector ? scope.querySelector('[data-finder]') : null;
    if (!finder) return;
    finder.querySelectorAll('.pillset button').forEach(b => b.addEventListener('click', () => {
      finder.querySelectorAll('.pillset button').forEach(x => x.classList.remove('is-on'));
      b.classList.add('is-on');
    }));
    const go = finder.querySelector('[data-finder-go]');
    if (go) go.addEventListener('click', () => {
      const sel = finder.querySelector('select');
      const url = sel && sel.value ? sel.value : (finder.getAttribute('data-default-url') || '/collections/all');
      if (url) window.location = url;
    });
  }

  /* ---------- init all ---------- */
  function initAll(scope) {
    scope = scope || document;
    window.__cartDrawerEnabled = !!$('#CartDrawer');
    initProduct(scope);
    initSticky(scope);
    initSearch(scope);
    initFinder(scope);
  }
  function initHeaderScroll() {
    const h = document.querySelector('.site-header');
    if (!h) return;
    const onScroll = () => h.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  document.addEventListener('DOMContentLoaded', () => { initAll(document); renderCartDrawer(); initHeaderScroll(); });
  /* back/forward cache restores an old copy of the page: refresh the basket */
  window.addEventListener('pageshow', e => { if (e.persisted) renderCartDrawer(); });

  /* ---------- Theme Editor lifecycle ---------- */
  document.addEventListener('shopify:section:load', e => initAll(e.target));
  document.addEventListener('shopify:section:select', e => {
    if (e.target.querySelector('#CartDrawer') || e.target.id === 'shopify-section-cart-drawer') openDrawer('#CartDrawer');
  });
})();
